import { render, staticRenderFns } from "./ComposeButton.vue?vue&type=template&id=1adb6e30&scoped=true&"
import script from "./ComposeButton.vue?vue&type=script&lang=js&"
export * from "./ComposeButton.vue?vue&type=script&lang=js&"
import style0 from "./ComposeButton.vue?vue&type=style&index=0&id=1adb6e30&scoped=true&lang=css&"
import style1 from "./ComposeButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb6e30",
  null
  
)

export default component.exports